import { sharedThemeTokens } from '@/templates/sharedThemeTokens.js';
import { merge } from 'lodash-es';

export const templateThemeTokens = merge(sharedThemeTokens, {});
